/**
 * Account API wrappers (APP-002 §28).
 *
 * Focused wrappers over the account identity + rename endpoints. The generic
 * `patchAccount` lives in dashboard.ts; this module re-exports the typed
 * account surface feature pages consume, plus a convenience rename helper
 * that sends an explicit, minimal body (never spreads arbitrary fields).
 *
 * Authentication and error parsing remain centralized in the API client.
 */
import { getAccountIdentity, patchAccount } from './dashboard';
import type {
  AccountResponse,
  DashboardIdentityResponse,
} from './dashboard-types';

export { getAccountIdentity };

export type { AccountResponse, DashboardIdentityResponse };

/**
 * Rename the account. Sends ONLY `{ name }` — never arbitrary fields — so the
 * browser cannot smuggle plan/status/entitlement edits through object spread
 * (APP-002 §33). Backend field constraints are enforced server-side; the form
 * layer also validates client-side with Zod.
 */
export function updateAccountName(
  name: string,
  signal?: AbortSignal,
): Promise<AccountResponse> {
  return patchAccount({ name }, signal);
}

/** Keep the generic PATCH available for future editable fields. */
export { patchAccount };
